import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Wat kosten kunststof kozijnen?",
    a: "De prijs hangt af van het aantal kozijnen, de afmetingen, het type beglazing en de gewenste kleur. Omdat elk project maatwerk is, komen wij gratis bij u langs om in te meten. U ontvangt daarna een heldere offerte zonder verrassingen — geheel vrijblijvend.",
  },
  {
    q: "Wat is de levertijd?",
    a: "Na akkoord op de offerte worden uw kozijnen op maat geproduceerd. Gemiddeld duurt dit 6 tot 8 weken. Wij plannen de montage direct met u in, zodat u precies weet waar u aan toe bent.",
  },
  {
    q: "Hoeveel garantie krijg ik?",
    a: "U krijgt 15 jaar garantie op zowel het materiaal als de montage. Onze kozijnen worden geplaatst door eigen, vaste monteurs — zo houden wij de kwaliteit volledig in eigen hand.",
  },
  {
    q: "Is een offerte echt vrijblijvend?",
    a: "Ja, volledig. Wij komen gratis bij u langs, meten alles nauwkeurig in en u ontvangt een offerte op maat. U beslist daarna in alle rust — zonder enige verplichting.",
  },
  {
    q: "Moet ik zelf iets voorbereiden voor de montage?",
    a: "Nee, wij regelen alles. Onze monteurs verwijderen de oude kozijnen, plaatsen de nieuwe, werken alles strak af en laten uw woning schoon achter — vaak binnen één dag per gevel.",
  },
];

export const FAQ = () => (
  <section className="bg-white py-24 md:py-32" data-testid="faq-section">
    <div className="mx-auto max-w-[1440px] px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-14">
      <Reveal className="lg:col-span-4">
        <span className="text-xs uppercase tracking-[0.25em] text-[#222]/40">Veelgestelde vragen</span>
        <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-[#2F3438] mt-6 leading-tight">Alles wat u wilt weten.</h2>
        <p className="text-[#222]/60 font-light leading-relaxed mt-6 max-w-sm">
          Staat uw vraag er niet tussen? Bel, app of mail ons gerust — wij denken graag met u mee.
        </p>
        <Link to="/offerte" data-testid="faq-offerte-cta" className="group inline-flex items-center gap-3 mt-8 bg-[#2F3438] text-white px-6 py-3.5 rounded-sm hover:bg-[#222] transition-colors duration-300">
          <span className="text-sm font-medium">Vraag vrijblijvend een offerte aan</span>
          <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform duration-300" />
        </Link>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-8">
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-[#E4E4E1]" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="font-display text-lg text-[#2F3438] text-left hover:no-underline py-6">{f.q}</AccordionTrigger>
              <AccordionContent className="text-[#222]/60 text-base font-light leading-relaxed pb-6">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
